import apiClient from './apiConfig';

export const getPassengers = async (page: number, perPage: number, search: string = '') => {
  try {
    const response = await apiClient.get(`/passengers?page=${page}&per_page=${perPage}&search=${encodeURIComponent(search)}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching passengers:', error);
    throw error;
  }
};

export const updatePassengerCategory = async (id: number, category: string) => {
  try {
    const response = await apiClient.put(`/passengers/${id}/category`, { category });
    return response.data;
  } catch (error) {
    console.error('Error updating passenger category:', error);
    throw error;
  }
};

export const registerStay = async (userId: number, amount: number, description?: string) => {
  try {
    const response = await apiClient.post('/stays', {
      user_id: userId,
      amount,
      description
    });
    return response.data;
  } catch (error) {
    console.error('Error registering stay:', error);
    throw error;
  }
};

export const getPointsHistory = async (userId: number) => {
  try {
    const response = await apiClient.get(`/passengers/${userId}/points-history`);
    return response.data;
  } catch (error) {
    console.error('Error fetching points history:', error);
    throw error;
  }
};

export const deletePassenger = async (id: number) => {
  try {
    const response = await apiClient.delete(`/passengers/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting passenger:', error);
    throw error;
  }
};

export const adjustPassengerPoints = async (id: number, points: number, reason: string) => {
  try {
    const response = await apiClient.post(`/passengers/${id}/points-adjustments`, { points, reason });
    return response.data;
  } catch (error) {
    console.error('Error adjusting passenger points:', error);
    throw error;
  }
};

export const voidPointTransaction = async (passengerId: number, transactionId: number, reason: string) => {
  try {
    const response = await apiClient.post(`/passengers/${passengerId}/point-transactions/${transactionId}/void`, { reason });
    return response.data;
  } catch (error) {
    console.error('Error voiding point transaction:', error);
    throw error;
  }
};
